import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../utils/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { deleteUserAccount } from '../api/general';
import { CONFIG } from "../config";
import { SidebarProvider } from "../components/SidebarContext";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import SidebarToggle from '../components/SidebarToggle';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import "../css/ProfileSettings.css";

axios.defaults.withCredentials = true;  

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let c of cookies) {
      const cookie = c.trim();
      if (cookie.startsWith(name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const ProfileSettings = () => {
  const [profile, setProfile] = useState({ 
                                          email: '', 
                                          first_name:'', 
                                          last_name:'', 
                                          phone:'',
                                          address:'',
                                          city:'',
                                          province:'',
                                          zipcode:'',
                                          available_balance: 0,
                                        });
  const [loading, setLoading] = useState(true);
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate ();
  const location = useLocation ();
  const [error, setError] = useState(null);
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const API_BASE = CONFIG.API_URL

  useEffect (() => {
    if (!loading) {
      if (!user) {
        navigate (`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, location, navigate]);

  useEffect(() => {
    axios.get(`${API_BASE}/api/me/`)
      .then(res => {
        setProfile(res.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);


  const handleDeleteAccount = async () => {
    if (!window.confirm (setlang === "en" ? "Your BidZone account is now deleted" : " حساب کاربریت برای همیشه حذف شد")) return ;
    try {
      await deleteUserAccount()
      logout();
      navigate(`/${lang}/gallery`)

      {setlang==="en"?
        alert("We have receieved your request. Your account will be removed permanenetly after review."):
        alert("درخواستت دریافت شد و پس از بررسی، دسترسی به حساب کاربریت حذف خواهد شد.  ")
      }

    } catch(err) {
      {setlang==="en"?
      alert("Failed to delete account."):
      alert("مشکلی رخ داد، لطفا دوباره وارد شو")
      }
    }
  }


  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

    if (loading) return <Loading />;  

  return (
    <>
      <NavbarLog />
      <SidebarProvider side={setlang}>
        <SidebarToggle />
      <div className={setlang==="en"?'PScenter-wrapper-en':'PScenter-wrapper-fa'}>
        {setlang==="en" && 
          <Sidebar />
        }

        {setlang==="en"?
        <>
          <div className='delete-account-container'>
          <h3>Deletion of your BidZone account</h3>
          <p>By deleting your account you will:</p>
          <ul>
            <li>loose access to your saved profile settings and information and bank accounts on this platform</li>
            <li>loose access to your saved bank accounts and transactions on this platform</li>
            <li>loose access to your communication messages, wishlist items, and past orders</li>
          </ul>
        <button className='delete-account-submit' onClick={()=>handleDeleteAccount()}>
          {setlang==="en"?"Delete BidZone account":"حذف حساب کاربری "}
        </button>
        </div>
        </>
        :
        <>
        <div className='delete-account-container' style={{direction:"rtl"}}>
          <h3>میخوای حساب کاربریت رو حذف کنی؟</h3>
          <p>با حذف کردن حساب کاربری:</p>
          <ul style={{textAlign:"right"}}>
            <li>تمام اطلاعات و دسترسی به تنضیمات حساب کاربری، شخصی و بانکی حذف خواهد شد</li>
            <li>تمام اطلاعات و دسترسی به مبادله های خرید و فروش، پرداخت ها و دریافت های حساب بانکی در این پلتفرم حذف خواهد شد</li>
            <li>تمام اطلاعات و دسترسی به پیام ها، پست ها و لیست علاقه مندی حذف خواهد شد </li>
          </ul>
          <button className='delete-account-submit' onClick={()=>handleDeleteAccount()}>
            {setlang==="en"?"Delete BidZone account":"حذف حساب کاربری "}
          </button>
        </div>
        </>
        }

        {setlang==="fa" && 
          <Sidebar />
        }
      </div>
      </SidebarProvider>
      <Footer />
    </>
  );
};

export default ProfileSettings;